/* PANERO: localize the existing LINE announcement (Qikify popup 120986). */
(() => {
  const copy = {
    ja: ['公式LINEはこちら', 'クーポン / 新作情報 / お問い合わせ', 'LOOK'],
    en: ['PANERO on LINE', 'Coupons / New arrivals / Contact', 'VIEW LINE'],
    ko: ['PANERO 공식 LINE', '쿠폰 / 신상품 소식 / 문의', 'LINE 보기'],
    'zh-tw': ['PANERO 官方 LINE', '優惠券 / 新品資訊 / 聯絡我們', '查看 LINE'],
    es: ['LINE oficial de PANERO', 'Cupones / Novedades / Contacto', 'VER LINE'],
    de: ['PANERO auf LINE', 'Gutscheine / Neuheiten / Kontakt', 'LINE ANSEHEN']
  };
  const selectors = ['.qsk-popup__box-title', '.qsk-popup__box-description', '.qsk-popup__submit-btn-text'];
  const recognized = selectors.map((_, index) => new Set(Object.values(copy).map(value => value[index])));
  let queued = false;
  const update = () => {
    queued = false;
    const language = (document.documentElement.lang || 'en').toLowerCase();
    const target = copy[language] || copy[language.split('-')[0]] || copy.en;
    document.querySelectorAll('.qsk-popup-announcement--120986').forEach(popup => {
      selectors.forEach((selector, index) => {
        const element = popup.querySelector(selector);
        if (!element) return;
        const text = element.textContent.trim();
        if (recognized[index].has(text) && text !== target[index]) {
          element.textContent = target[index];
        }
      });
    });
  };
  const schedule = () => {
    if (!queued) {
      queued = true;
      requestAnimationFrame(update);
    }
  };
  const start = () => {
    update();
    new MutationObserver(schedule).observe(document.body, {childList: true, characterData: true, subtree: true});
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, {once: true});
  } else {
    start();
  }
})();
